import {BrowserRouter, Route, Routes} from 'react-router-dom'
import LandingPage from "./Components/LandingPages/LandingPage";
import Contact from "./Components/LandingPages/Contact";
import About from "./Components/LandingPages/About";
import FAQ from "./Components/LandingPages/FAQ";
import Activities from "./Components/LandingPages/Activities";
import Login from "./Components/Login";
import Content from "./Components/Content";
import Messages from "./Components/AppPages/Messages";
import {AuthProvider} from "./contexts/AuthProvider";

function App() {
  return (
      <AuthProvider>
          <BrowserRouter>
              <div className={`h-dvh font-carlita w-dvw`}>
                  <Routes>
                      <Route path="/" element={<LandingPage />} />
                      <Route path="/contact-us" element={<Contact />} />
                      <Route path="/about-us" element={<About />} />
                      <Route path="/faqstestimonials" element={<FAQ />} />
                      <Route path="/galleryactivities" element={<Activities />} />
                      <Route path="/login" element={<Login />} />
                      <Route path="/messages" element={<Messages />} />
                      <Route path="/content" element={<Content />} />
                  </Routes>
              </div>
          </BrowserRouter>
      </AuthProvider>
  );
}

export default App;
